// Keeps <html data-theme> in step with the server across Turbo visits (FRO-155).
//
// The server stamps the theme on <html> for first paint, but a Turbo visit replaces only <body>.
// When the theme a page was rendered in differs from the one already on screen — signing in on a
// browser whose login page knew nothing of the person's saved theme, or a choice made in another
// tab — the new body carries it in data-appearance-theme and this copies it up before the render.
//
// Not on a morph refresh: that is the same page re-rendered for a broadcast, and it could carry
// the old theme back while the appearance controller's save is still in flight.
document.addEventListener("turbo:before-render", (event) => {
  if (event.detail.renderMethod === "morph") return

  const theme = event.detail.newBody?.dataset.appearanceTheme
  if (theme === undefined) return

  const root = document.documentElement
  if (theme) {
    root.setAttribute("data-theme", theme)
  } else {
    root.removeAttribute("data-theme")
  }
})
